module.exports = __webpack_public_path__ + "img/x-circle.e30bc325.svg";